angular.module('mouseInteraction', [])
    .directive('ngDragEnd', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var el = element[0];
                el.draggable = true;
                var fn = $parse(attrs.ngDragEnd);
                element.bind('dragend', function (event) {
                    scope.$apply(function () {
                        fn(scope, { event: event });
                    });
                });
            }
        }
    }])
    .directive('ngDragStart', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var el = element[0];
                el.draggable = true;
                var fn = $parse(attrs.ngDragStart);
                element.bind('dragstart', function (event) {
                    scope.$apply(function () {
                        fn(scope, { event: event });
                    });
                });
            }
        }
    }])
    .directive('ngDragOver', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.ngDragOver);
                element.bind('dragover', function (event) {
                    scope.$apply(function () {
                        fn(scope, { event: event });
                    });
                });
            }
        }
    }])
    .directive('ngRightclick', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.ngRightclick);
                element.bind('contextmenu', function (event) {
                    scope.$apply(function () {
                        event.preventDefault();
                        fn(scope, { $event: event, key: attrs.tokenHashKey });
                    });
                });
        }
    }}]);